import styled from 'styled-components';
import { StyledRteHtmlTextNoFont } from '../../../../../../../inputs/rich-text/style/StyledRteHtmlTextNoFont.tsx';

export const OptionsGroupDividerLabel = styled.div`
  ${StyledRteHtmlTextNoFont};
  margin-left: 8px;
  font-size: 12px;
  padding: 0 4px;
  background-color: #fff;
  color: ${props => props.theme.colorText};
  pointer-events: visible;
  p,
  a,
  ol,
  ul,
  dl {
    font-size: 12px;
    margin-bottom: 0;
  }

  // Text ellipsis overflow
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
